module.exports = __webpack_public_path__ + "img/infoguidance_mov_09.1929e5e3.jpg";